export enum RegexValue {
  bin,
  dec,
  hex
}
